import React from 'react';

const ApprovalCallbackModal = ({ appData, numberWithCommas, dealStips, dealerNotes }) => {
    return (
        <div className="modal fade" id="approval_callback_modal" tabIndex={-1} role="dialog" aria-labelledby="approval_callback_modal" aria-hidden="true">
            <div className="modal-dialog modal-xl" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="approvalscallbackmodallabel">Call Back Information</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="table-responsive">
                            <p className="CB_Header">Tracir Financial Services</p>
                            <p className="CB_sub_Header">{appData.rec_app_status}</p>
                            <table className=" table table-striped table-bordered">
                                <tbody>
                                    <tr>
                                        <td colSpan={2} rowSpan={1} className="CI_Modal"><h4>Customer Information</h4></td>
                                        <td>&nbsp;</td>
                                        <td colSpan={2} rowSpan={1} className="FI_Modal"><h4>Financing Information</h4></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Applicant</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_app_first_name} {appData.rec_app_last_name}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Max Advance</h5></td>
                                        <td className="CB_Modal_Value"><span>${numberWithCommas(appData.rec_unpaid_balance)}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Co-Applicant, if any</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_coapp_first_name} {appData.rec_coapp_last_name}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>GAP Protection</h5></td>
                                        <td className="CB_Modal_Value"><span>${numberWithCommas(appData.rec_gap)}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Application #</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_application_number}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>FL Doc Stamp Tax, if any</h5></td>
                                        <td className="CB_Modal_Value"><span>${numberWithCommas(appData.rec_credit_life_ins)}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Application Date</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.app_received_date}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Total Amount Financed</h5></td>
                                        <td className="CB_Modal_Value"><span>${numberWithCommas(appData.rec_est_amt_financed)}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Decision Date</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.app_decision_date}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Discount/Lender Fee</h5></td>
                                        <td className="CB_Modal_Value"><span>${appData.rec_calc_discount}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Dealer</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_dealer_name}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Origination Fee</h5></td>
                                        <td className="CB_Modal_Value"><span>${parseFloat(appData.rec_orig_fee).toFixed(2)}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>USAC Branch</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_dealer_branch}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5 className="dealer_proceeds"><strong>Dealer Proceeds</strong></h5></td>
                                        <td className="CB_Modal_Value_DP"><span className="CB_Modal_Value_DP">${numberWithCommas(appData.rec_dealer_proceeds)}</span></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2} rowSpan={1} className="VI_Header"><h4>Vehicle Information</h4></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Payment Frequency</h5></td>
                                        <td className="CB_Modal_Value"><span>{appData.rec_payment_freq}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>New/Used</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_veh_year}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Maximum # of Payments</h5></td>
                                        <td className="CB_Modal_Value"><span>{appData.rec_term_months}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Make</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_veh_make}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Maximum Payment</h5></td>
                                        <td className="CB_Modal_Value"><span>${appData.rec_payment}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Model</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_veh_model}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Minimum Down Payment</h5></td>
                                        <td className="CB_Modal_Value"><span>${appData.req_cash_down}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Trim</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_veh_trim}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Net Trade In</h5></td>
                                        <td rowSpan={1} className="CB_Modal_Value"><span>${numberWithCommas(appData.rec_net_trade)}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>VIN #</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_vin}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Rate</h5></td>
                                        <td rowSpan={1} className="CB_Modal_Value"><span>{appData.rec_buyrate}%</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Mileage</h5></td>
                                        <td><span className="CB_Modal_Item">{numberWithCommas(appData.rec_veh_mileage)} miles</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5 className="Analyst_Header">Analyst</h5></td>
                                        <td className="Analyst_Item"><span className="Analyst_Item">{appData.rec_analyst_fullname}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className="Remind"><span><span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;REMINDERS</span>: &nbsp;</span></p>

                            <ul>
                                <li className="Remind_item"><span>Title and assignment section of the retail installment contract must refer to <span className="Remind_item_color">Tracir Financial Services</span>.</span></li>
                                <li className="Remind_item"><span>All lienholder information should be addressed to&nbsp;</span> <span className="Remind_item_color"><span>P.O. Box 57545, Jacksonville, FL, &nbsp;32241</span>.</span></li>
                                <li className="Remind_item"><span>Please send all closing documents to&nbsp;<span className="Remind_item_color">8120 Nations Way, STE 208,&nbsp;Jacksonville, FL &nbsp;32256</span>.&nbsp;</span></li>
                                <li><span className="Remind_item"><a href="https://ftac.dealersocket.com/desk" target="_blank" rel="noreferrer">Submit electronic contracts/stips to <span className="Remind_item_color">Tracir Financial Services</span>.</a></span></li>
                            </ul>

                            <p className="Remind_item"><span>The following is a list of our ELT # for those of you in an ELT state:</span></p>

                            <table align="center" className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td className="Remind_item"><span>Florida: 232767767</span></td>
                                        <td className="Remind_item"><span>North Carolina: 41401159</span></td>
                                        <td className="Remind_item"><span>Virginia: ACP01</span></td>
                                        <td className="Remind_item"><span>Ohio: E09100</span></td>
                                    </tr>
                                    <tr>
                                        <td className="Remind_item"><span>Georgia: 1106989358</span></td>
                                        <td className="Remind_item"><span>South Carolina: 34127734</span></td>
                                        <td className="Remind_item"><span>Maryland: 6781</span></td>
                                        <td className="Remind_item"><span>Texas: 27364763300&nbsp;</span></td>
                                    </tr>
                                </tbody>
                            </table>

                            <p>&nbsp;</p>

                            <table align="center" className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td className="Stip_head"><h5>Stipulations</h5></td>
                                    </tr>
                                    {dealStips.map((dealStip, index) => (
                                        <tr key={index}>
                                            <td><span className="Stip_item"></span>{dealStip}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <p>&nbsp;</p>
                            <p>&nbsp;</p>
                            <p>&nbsp;</p>

                            <table align="center" className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td className="Notes_Head"><span>Tracir Financial Services Notes to Dealer</span></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {dealerNotes.map((dealerNote, index) => (
                                                <p key={index}><span className="Note_item">{dealerNote}</span></p>
                                            ))}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <p>&nbsp;</p>
                            <p>&nbsp;</p>
                            <p>&nbsp;</p>

                            <div>&nbsp;</div>

                            <div>
                                <table align="center" className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <td><span className="Contact">Underwriting Phone #</span></td>
                                            <td><span className="Contact">877-280-9267</span></td>
                                        </tr>
                                        <tr>
                                            <td><span className="Contact">FAX YOUR LOAN PACKET to</span></td>
                                            <td><span className="Contact">888-769-3390</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(ApprovalCallbackModal);